import { Question, Questionnaire, Restaurant } from '@lib/types';
import { createAction, props } from '@ngrx/store';

export const loadQuestionnaire = createAction(
  '[RestaurantManager] Load Questionnaire',
  props<{ id: number }>()
);

export const loadQuestionnaireSuccess = createAction(
  '[RestaurantManager] Load Questionnaire Success',
  props<{ questionnaire: Questionnaire }>()
);

export const loadQuestionnaireFailure = createAction(
  '[RestaurantManager] Load Questionnaire Failure',
  props<{ error: any }>()
);

export const updateQuestionnaire = createAction(
  '[RestaurantManager] Update Questionnaire',
  props<{ restaurant: Restaurant, questions: Question[] }>()
);

export const updateQuestionnaireSuccess = createAction(
  '[RestaurantManager] Update Questionnaire Success',
  props<{ questionnaire: Questionnaire }>()
);

export const updateQuestionnaireFailure = createAction(
  '[RestaurantManager] Update Questionnaire Failure',
  props<{ error: any }>()
);
